import { SuborderArticlesTable } from "@/components/stock/suborder-articles-table";
import type { SuborderPanelBaseProps } from "../../shared";

export function SuborderArticles({ orderId, suborderId }: SuborderPanelBaseProps) {
	/** Render */
	return (
		<SuborderArticlesTable
			orderId={orderId}
			suborderId={suborderId}
			variant="table"
		/>
	);
}
